import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createTrainingCourse } from "../../../actions/admin/certification/training_course_action";
import { categoryList } from "../../../actions/admin/certification/category_action";
import { useNavigate } from "react-router-dom";

const CreateTrainingCourseModel = (props) => {
  const dispatch = useDispatch();
  const [course, setAddCoure] = useState({
    name: "",
    category: "",
    level: "",
    duration: "",
    duration_type: "",
    price: "",
  });
  const state = useSelector((state) => state.trainingCourseReducer);

  const categoryState = useSelector((state) => state.categoryReducer);
  const [show, setShow] = useState(props.show);

  useEffect(() => {
    dispatch(categoryList());
  }, []);

  const handleClose = () => {
    props.handelCloseCrourseModel();
    setShow(false);
  };

  const handleCourseSubmit = (e) => {
    e.preventDefault();
    dispatch(createTrainingCourse(course));
  };

  if (state.is_done && show) {
    props.handelCloseCrourseModel();
    setShow(false);
  }

  return (
    <div>
      <Modal
        className="custom-modal"
        show={show}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Training Course </Modal.Title>
        </Modal.Header>
        <Modal.Body className="err-model-body">
          <form onSubmit={handleCourseSubmit}>
            <div className={"row"}>
              <div className="col-lg-5 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Select Category
                  </label>
                  <select
                    className="form-control"
                    name={"category"}
                    onChange={(e) =>
                      setAddCoure({ ...course, category: e.target.value })
                    }
                  >
                    <option>Select Category </option>
                    {categoryState.list &&
                      categoryState.list.map((li, i) => (
                        <option value={li.id} key={i}>
                          {li.name}{" "}
                        </option>
                      ))}
                  </select>
                  <span className="error-msg">
                    {state.errors.category_id ? state.errors.category_id : ""}
                  </span>
                </div>
              </div>

              <div className="col-lg-7 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Course Name
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={course.name}
                    onChange={(e) =>
                      setAddCoure({ ...course, name: e.target.value })
                    }
                  />
                  <span className="error-msg">
                    {state.errors.name ? state.errors.name : ""}
                  </span>
                </div>
              </div>
            </div>

            <div className={"row"}>
              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">Level</label>
                  <select
                    className="form-control"
                    name={"level"}
                    onChange={(e) =>
                      setAddCoure({ ...course, level: e.target.value })
                    }
                  >
                    <option>Select Level</option>
                    <option value={"Beginner"}>Beginner</option>
                    <option value={"Intermediate"}>Intermediate</option>
                    <option value={"Advance"}>Advance</option>
                  </select>
                  <span className="error-msg">
                    {state.errors.is_paid ? state.errors.is_paid : ""}
                  </span>
                </div>
              </div>

              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">Price</label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={course.price}
                    onChange={(e) =>
                      setAddCoure({ ...course, price: e.target.value })
                    }
                  />
                  <span className="error-msg">
                    {state.errors.price ? state.errors.price : ""}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Duration(1 to ...)
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={course.duration}
                    onChange={(e) =>
                      setAddCoure({ ...course, duration: e.target.value })
                    }
                  />
                  <span className="error-msg">
                    {state.errors.duration ? state.errors.duration : ""}
                  </span>
                </div>
              </div>

              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Duration Type
                  </label>
                  <select
                    className="form-control"
                    name={"level"}
                    onChange={(e) =>
                      setAddCoure({ ...course, duration_type: e.target.value })
                    }
                  >
                    <option>Select Type</option>
                    <option value={"Hours"}>Hours</option>
                    <option value={"Days"}>Days</option>
                    <option value={"Weeks"}>Weeks</option>
                    <option value={"Month"}>Month</option>
                    <option value={"Year"}>Year</option>
                  </select>
                  <span className="error-msg">
                    {state.errors.duration_type
                      ? state.errors.duration_type
                      : ""}
                  </span>
                </div>
              </div>
            </div>

            <div className={"row"}>
              <div className="col-lg-12 text-right">
                <input
                  type="submit"
                  name="submit"
                  value="Submit"
                  className="btn-common px-5 mt-15"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default CreateTrainingCourseModel;
